// Floating WhatsApp click-to-chat button (free wa.me API, no keys).
// Config comes from Site Settings → Bouton WhatsApp (admin), injected by
// SiteBodyEndContent.razor as window.__waConfig = {enabled, number, message}.
// No hardcoded number — disabled until configured in the back office.
(function () {
    if (location.pathname.toLowerCase().indexOf('/admin') === 0) return; // frontend only

    function inject() {
        var cfg = window.__waConfig;
        if (!cfg || !cfg.enabled || !cfg.number) return;        // not configured → no button
        if (document.getElementById('bo-wa-btn')) return;

        var url = 'https://wa.me/' + String(cfg.number).replace(/\D/g, '');
        if (cfg.message) url += '?text=' + encodeURIComponent(cfg.message);

        var a = document.createElement('a');
        a.id = 'bo-wa-btn';
        a.href = url;
        a.target = '_blank';
        a.rel = 'noopener';
        a.setAttribute('aria-label', 'Contactez-nous sur WhatsApp');
        a.style.cssText = 'position:fixed;bottom:22px;right:22px;z-index:1200;width:56px;height:56px;border-radius:50%;background:#25D366;display:flex;align-items:center;justify-content:center;box-shadow:0 6px 20px rgba(0,0,0,.28);transition:transform .15s ease';
        a.addEventListener('mouseenter', function () { a.style.transform = 'scale(1.08)'; });
        a.addEventListener('mouseleave', function () { a.style.transform = 'scale(1)'; });
        a.innerHTML = '<svg width="30" height="30" viewBox="0 0 32 32" fill="#fff" aria-hidden="true"><path d="M16 .5C7.4.5.5 7.4.5 16c0 2.8.7 5.4 2 7.8L.5 31.5l7.9-2c2.3 1.2 4.9 1.9 7.6 1.9 8.6 0 15.5-6.9 15.5-15.5S24.6.5 16 .5zm0 28c-2.4 0-4.7-.6-6.7-1.8l-.5-.3-4.7 1.2 1.2-4.6-.3-.5C3.9 20.4 3.2 18.2 3.2 16 3.2 8.9 9 3.2 16 3.2S28.8 8.9 28.8 16 23 28.5 16 28.5zm7.4-9.6c-.4-.2-2.4-1.2-2.7-1.3-.4-.1-.6-.2-.9.2-.3.4-1 1.3-1.2 1.5-.2.2-.4.3-.8.1-.4-.2-1.7-.6-3.2-2-1.2-1-2-2.3-2.2-2.7-.2-.4 0-.6.2-.8.2-.2.4-.4.5-.6.2-.2.2-.4.4-.6.1-.3 0-.5 0-.7-.1-.2-.9-2.1-1.2-2.9-.3-.8-.6-.7-.9-.7h-.7c-.2 0-.6.1-.9.5-.3.4-1.2 1.2-1.2 2.9s1.2 3.4 1.4 3.6c.2.2 2.4 3.7 5.9 5.2.8.4 1.5.6 2 .8.8.3 1.6.2 2.2.1.7-.1 2.4-1 2.7-1.9.3-.9.3-1.7.2-1.9-.1-.2-.3-.3-.7-.5z"/></svg>';
        document.body.appendChild(a);
    }

    // window.__waConfig is set by an inline <script> rendered at body-end (during
    // parse), so it is available by DOMContentLoaded.
    if (document.readyState !== 'loading') inject();
    else document.addEventListener('DOMContentLoaded', inject);

    // Enhanced navigation (filters, sort, pager of an interactive island) replaces the
    // body content: the button, appended to <body> at load, vanished on the first
    // filter click (Babylone, 14/10/2026). Re-inject after every enhanced load; the
    // Blazor object may appear after this script, so poll for it briefly.
    function hook() {
        if (!window.Blazor || !window.Blazor.addEventListener) return false;
        try { window.Blazor.addEventListener('enhancedload', inject); } catch (e) { return false; }
        return true;
    }
    if (!hook()) {
        var tries = 0;
        var timer = setInterval(function () { if (hook() || ++tries > 40) clearInterval(timer); }, 500);
    }
    document.addEventListener('pd:enhancedload', inject);
})();
